import { HttpClient } from "@angular/common/http";
import { EventEmitter, Injectable } from "@angular/core";
import { ApiPaginationResponseDataNonNullable } from "app/shared/models/api-response.model";
import { Observable } from "rxjs";
import { AuthService } from "../../base-module/base-service/auth.service";
import { UtilitesService } from "../../base-module/base-service/utilites.service";
import { OperadorCartaConsorcioModel } from "../models/operador-carta-consorcio.model";

@Injectable()
export class OperadorCartaConsorcioService {
    public empresaPadrao = new EventEmitter<any>();

    constructor(private authService: AuthService, private _http: HttpClient, public utilitesService: UtilitesService) {}

    /**
     * Operador de Carta Consorcio por id
     * @param id ID da Operador de Carta Consorcio
     */
    getById(id: number): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + "consorcio/operador-carta-consorcio/" + id, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Lista de Operador de Carta Consorcio
     * @param id ID da Operador de Carta Consorcio
     */
    getAll(
        params: Record<string, unknown>
    ): Observable<ApiPaginationResponseDataNonNullable<OperadorCartaConsorcioModel>> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if (paramHttp !== null && paramHttp !== "") {
            env = "?" + paramHttp;
        }

        return this._http.get<ApiPaginationResponseDataNonNullable<OperadorCartaConsorcioModel>>(
            this.utilitesService.urlPrefix + "consorcio/operador-carta-consorcio" + env,
            {
                headers: this.authService.getAuthHeaders(),
            }
        );
    }

    /**
     * Delete de Operador de Carta Consorcio
     * @param id ID da Operador de Carta Consorcio
     */
    delete(id: number): Observable<any> {
        return this._http.delete(this.utilitesService.urlPrefix + "consorcio/operador-carta-consorcio/" + id, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Cadastra Operador de Carta Consorcio
     * @param params Json Operador de Carta Consorcio
     */
    create(params: any): Observable<any> {
        return this._http.post(
            this.utilitesService.urlPrefix + "consorcio/operador-carta-consorcio",
            JSON.stringify(params),
            { headers: this.authService.getAuthHeaders() }
        );
    }

    /**
     * Atualiza Operador de Carta Consorcio
     * @param params Json Operador de Carta Consorcio
     */
    update(id: number, params: any): Observable<any> {
        return this._http.put(
            this.utilitesService.urlPrefix + "consorcio/operador-carta-consorcio/" + id,
            JSON.stringify(params),
            { headers: this.authService.getAuthHeaders() }
        );
    }
}
